import './PriceFilter.css'

function PriceFilter(props) {
    return (
        <div className='priceFilter' open={(props.open === undefined || props.open === null) ? true : props.open}>
            <div>
                <label htmlFor='from'>Prezzo minimo:</label>
                <input placeholder='es. 200' type="text" value={props.from} name="from" onChange={e => {e.preventDefault(); props.fromChange(e.target.value)}}/>
            </div>
            <div>
                <label htmlFor='to'>Prezzo massimo:</label>
                <input placeholder='es. 800' type="text" value={props.to} name="to" onChange={e => {e.preventDefault(); props.toChange(e.target.value)}}/>
            </div>
        </div>
    )
}

export default PriceFilter